<template>
  <div class="factor" v-show="show" :style="custom.style" @click="toStop">
    <div class="filter-part">
      <template v-if="filterType === 'text'">
          <Input placeholder="请输入关键字" v-model="value">
            <!-- <Button slot="append" icon="ios-search" @click="ok"></Button> -->
          </Input>
        </template>
        <template v-else-if="filterType === 'date'">
          <DatePicker v-model="dateRange" format="yyyy-MM-dd" type="daterange" confirm placement="bottom-end" placeholder="请选择日期区间" style="width: 220px"></DatePicker>
        </template>
        <template v-else-if="filterType === 'number'">
          <InputNumber v-model="numRange[0]"></InputNumber> -
          <InputNumber v-model="numRange[1]"></InputNumber>
        </template>
        <template v-else-if="filterType === 'select'">
          <div v-if="custom.fuzzy_search" style="margin-bottom: 10px;">
            <Input placeholder="字段搜索" v-model="checkValue" @on-change="checkValueChange">
              <!-- <Button slot="append" icon="ios-search" @click="ok"></Button> -->
            </Input>
          </div>
          <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom: 10px;">
            <Checkbox
                :indeterminate="indeterminate"
                :value="checkAll"
                @click.prevent.native="handleCheckAll">全选</Checkbox>
        </div>
          <CheckboxGroup v-model="selecteds" @on-change="selectedsChange" style="min-height: 180px;overflow: auto;">
            <Checkbox v-for="m in checkOptions" :key="m.value" :label="m.value">{{m.label}}</Checkbox>
          </CheckboxGroup>
        </template>
    </div>
    <div class="filter-action">
      <Button type="text" :disabled="isdisabled" @click="ok">筛选</Button>
      <Button type="text" @click="reset">重置</Button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterCard',
  props: {
    scrollId: String,
    custom: {
      pageX: 0,
      pageY: 0,
      type: ''
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dateRange: ['', ''],
      value: '',
      numRange: [null, null],
      selecteds: [],
      hasValue: false, // 加载table后监听滚动flag
      indeterminate: false,
      checkAll: false,
      checkValue: '',
      checkOptions: []
    }
  },
  computed: {
    filterType () {
      return this.custom.type
    },
    isdisabled: {
      get () {
        let bool = this.selecteds.length || this.dateRange[0] || this.dateRange[1] || this.value || this.numRange[0] || this.numRange[1]
        if (this.numRange[0] !== undefined && this.numRange[0] !== null && this.numRange[0] !== '') {
          bool = true
        }
        if (this.numRange[1] !== undefined && this.numRange[1] !== null && this.numRange[1] !== '') {
          bool = true
        }
        if (bool) {
          return false
        } else {
          return true
        }
      },
      set (n) {
      }
    }
  },
  methods: {
    checkValueChange () {
      this.checkOptions = this.custom.options.filter(x => x.value.includes(this.checkValue))
    },
    handleCheckAll () {
      if (this.indeterminate) {
        this.checkAll = false
      } else {
        this.checkAll = !this.checkAll
      }
      this.indeterminate = false

      if (this.checkAll) {
        this.selecteds = []
        this.checkOptions.forEach(m => {
          this.selecteds.push(m.value)
        })
      } else {
        this.selecteds = []
      }
    },
    selectedsChange (data) {
      if (this.checkOptions && data.length === this.checkOptions.length) {
        this.indeterminate = false
        this.checkAll = true
      } else if (data.length > 0) {
        this.indeterminate = true
        this.checkAll = false
      } else {
        this.indeterminate = false
        this.checkAll = false
      }
    },
    toStop (e) {
      e.stopPropagation()
    },
    // 清除数据
    init () {
      let type = this.custom.type
      let val = ''
      if (type === 'text') {
        this.value = ''
        val = this.type
      } else if (type === 'date') {
        this.dateRange = ['', '']
        val = []
      } else if (type === 'number') {
        this.numRange = [null, null]
        val = [null, null]
      } else if (type === 'select') {
        this.selecteds = []
        val = []
        this.checkAll = false
        this.indeterminate = false
      }
      this.checkValue = ''
      return val
    },
    reset () {
      let initVal = this.init()
      this.checkOptions = this.custom.options
      this.$emit('filterEvent', {
        type: this.custom.type,
        field: this.custom.field,
        opt_type: this.custom.opt_type,
        value: initVal
      })
      this.$emit('close')
    },
    cancel () {
      let initVal = this.init()
      this.$emit('filterEvent', {
        type: this.custom.type,
        field: this.custom.field,
        opt_type: this.custom.opt_type,
        value: initVal
      })
      this.$emit('close')
    },
    ok (e) {
      e.stopPropagation()
      let type = this.custom.type
      let val = ''
      if (type === 'text') {
        val = this.value
      } else if (type === 'date') {
        val = [this.$formatDate(this.dateRange[0]), this.$formatDate(this.dateRange[1])]
      } else if (type === 'number') {
        val = this.numRange
      } else if (type === 'select') {
        val = this.selecteds
      }
      this.$emit('filterEvent', {
        type: this.custom.type,
        field: this.custom.field,
        opt_type: this.custom.opt_type,
        value: val
      })
      this.$emit('close')
    },
    closeEven () {
      this.$emit('close')
    }
  },
  watch: {
    custom: {
      handler (n) {
        if (n.type && !this.hasValue) {
          this.hasValue = true
          let overflowEl = document.getElementsByClassName('ivu-table-overflowX')
          if (overflowEl) {
            for (let i = 0; i < overflowEl.length; i++) {
              overflowEl[i].onscroll = (e) => {
                this.$emit('close')
              }
            }
          }
        }
        this.checkOptions = n.options ? n.options.filter(x => x.value.includes(this.checkValue)) : []
        if (n.type === 'text') {
          this.value = n.value || ''
        } else if (n.type === 'date') {
          this.dateRange = n.value || ['', '']
        } else if (n.type === 'number') {
          this.numRange = n.value || [null, null]
        } else if (n.type === 'select') {
          this.selecteds = n.value || []
        }
        this.selectedsChange(this.selecteds)
      },
      deep: true
    }
  },
  mounted () {
    document.body.addEventListener('click', this.closeEven)
    document.body.addEventListener('dblclick ', this.closeEven) // 双击
    document.body.addEventListener('contextmenu', this.closeEven) // 右击
    let el = document.getElementById(this.scrollId)
    el && el.addEventListener('scroll', this.closeEven)
  },
  beforeDestroy () {
    let el = document.getElementById(this.scrollId)
    el && el.removeEventListener('scroll', this.closeEven)
    document.body.removeEventListener('click', this.closeEven)
    document.body.removeEventListener('dblclick ', this.closeEven) // 双击
    document.body.removeEventListener('contextmenu', this.closeEven) // 右击
  }
}
</script>

<style lang="stylus">
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}

.factor {
  min-width 140px
  // max-height 240px
  background: #fff;
  text-align: left;
  margin: 5px 0;
  padding-top: 20px;
  box-sizing: border-box;
  border-radius: 4px;
  z-index: 99;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  .iconfont {
    margin-right: 3px;
  }
  .filter-part{
    padding: 0 10px;
  }
  .filter-action{
    margin-top 10px
    padding: 0 10px;
    border-top 1px solid #ebeef5
    .ivu-btn{
      padding-left: 0;
    }
  }
  .ivu-checkbox-group-item{
    display block
    margin-top 5px
  }
}
</style>



// WEBPACK FOOTER //
// src/components/filtercard/FilterCard.vue